export class VPNSTAT {
    Type: string = "VPNSTAT";
    SerialNumber: string;
    Date: Date;
    Status: number;
    VPNName: string;
}